import Modal from "./Modal";

import UserEditor from "../editors/UserEditor";
import useBrowser from "../../hooks/useBrowser";

const UserModal = ({ userId, open, onClose, onSave }) => {
  const { windowHeight } = useBrowser();

  return (
    <Modal
      title={userId ? "Update User" : "Add User"}
      open={open}
      onClose={onClose}
      height={`${windowHeight}px`}
    >
      <UserEditor
        onSave={onSave}
        userId={userId}
      />
    </Modal>
  );
};

export default UserModal;
